const secondsToMilliseconds = (seconds) => seconds * 1e3;
const millisecondsToSeconds = (milliseconds) => milliseconds / 1e3;
export {
  millisecondsToSeconds,
  secondsToMilliseconds
};
//# sourceMappingURL=time-conversion.js.map
